<div class="list-group-item no-padding">
  <br>
  <p class="list-group-item-text">
    <strong>Talhões: </strong>
    <span ng-repeat="gleba in recomendacao.glebas track by $index">
      <span ng-show="$index > 0">, </span>
      {{gleba.descricao | humanize}} ({{gleba.area_total || 0 | number:2}} ha)
    </span>
  </p>
  <p class="list-group-item-text">
    <table class="table height-100 no-padding">
      <thead>
        <tr>
          <th class="no-padding-left">Produto</th>
          <th class="text-right">Dose</th>
          <th class="text-right">Unidade</th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="produto in recomendacao.insumos track by $index">
          <td class="no-padding-left vertical-middle">{{produto.descricao}}</td>
          <td class="text-right">{{produto.dose | number:3}}</td>
          <td class="text-right">{{produto.unidade.abreviatura}}/ha</td>
        </tr>
      </tbody>
    </table>
  </p>
  <span class="text-muted">
    <p class="list-group-item-text"><strong>Vazão: </strong>{{recomendacao.vazao | number:2}} l/ha</p>
    <p class="list-group-item-text" ng-show="recomendacao.bico">
      <strong>Bico: </strong>{{recomendacao.bico}}
    </p>
    <p class="list-group-item-text" ng-show="recomendacao.pressao.valor">
      <strong>Pressão: </strong>{{recomendacao.pressao.valor | number:0}} {{recomendacao.pressao.unidade}}
    </p>
    <p class="list-group-item-text"><strong>Cultura: </strong>{{recomendacao.atividade.descricao | humanize}}</p>
    <p class="list-group-item-text" ng-show="recomendacao.umidade.minima || recomendacao.umidade.maxima">
      Umidade
      <span ng-show="recomendacao.umidade.minima">
        acima de <strong>{{recomendacao.umidade.minima | number:0}}%</strong>
      </span>
      <span ng-show="recomendacao.umidade.maxima">
        abaixo de <strong>{{recomendacao.umidade.maxima | number:0}}%</strong>
      </span>
    </p>
    <p class="list-group-item-text" ng-show="recomendacao.temperatura.minima || recomendacao.temperatura.maxima">
      Temperatura
      <span ng-show="recomendacao.temperatura.minima">
        acima de <strong>{{recomendacao.temperatura.minima | number:0}}°C</strong>
      </span>
      <span ng-show="recomendacao.temperatura.maxima">
        abaixo de <strong>{{recomendacao.temperatura.maxima | number:0}}°C</strong>
      </span>
    </p>
    <p class="list-group-item-text" ng-show="recomendacao.temperatura.minima || recomendacao.temperatura.maxima">
      Velocidade
      <span ng-show="recomendacao.temperatura.minima">
        mínima <strong>{{recomendacao.velociadade.minima | number:0}} km/h</strong>
      </span>
      <span ng-show="recomendacao.temperatura.maxima">
        máxima <strong>{{recomendacao.velociadade.maxima | number:0}} km/h</strong>
      </span>
    </p>
    <p class="list-group-item-text" ng-show="recomendacao.vento.maxima">
      Vento
      <span ng-show="recomendacao.temperatura.maxima">
        máxima <strong>{{recomendacao.vento.maxima | number:0}} km/h</strong>
      </span>
    </p>
    <p class="list-group-item-text" ng-show="recomendacao.horas_sem_chuva">
      <strong>{{recomendacao.horas_sem_chuva | number:0}} horas</strong> sem chuva
    </p>
    <p class="list-group-item-text" ng-show="recomendacao.observacao">
      <strong>Observação: </strong> {{recomendacao.observacao}}
    </p>
    <p class="list-group-item-text">
      <strong>Período:</strong>
      {{getDateFormat(recomendacao.data_inicio)}}
      até
      {{getDateFormat(recomendacao.data_termino)}}
    </p>
    <p class="list-group-item-text"><strong>Recomendante: </strong>{{recomendacao.recomendante.nome | humanize}}</p>
  </span>
</div>
